
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router/index';
import AnimatedBackground from './components/feature/AnimatedBackground';
import InteractiveElements from './components/feature/InteractiveElements';
import './i18n';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AnimatedBackground />
      <InteractiveElements>
        <AppRoutes />
      </InteractiveElements>
    </BrowserRouter>
  );
}

export default App;
